export default {
  filters: {
    sac_status_sac: 'Attendance status',
    sac_status_other: 'New status',
    names: 'Groups',
    channels_listening: 'Listening channels',
    channels_proprietary: 'Proprietary channels',
    themes: 'Themes',
    pids: 'Posts by id',
    genders: 'Gender',
    polarities: 'Sentiment',
    tags: 'Tags',
    favorite: 'Checked posts',
    dark_post: 'Post type',
    sac_last_status: 'Old status',
    sac_replier: 'Agents',
    sac_type: 'Interaction',
    pages: 'Pages',
    uids: 'Authors',
    contracts: 'Contract',
    bots: 'Bot',
    category: 'Category',
  },
  selected: 'selected',
  selectedPlural: 'selected',
};
